module.exports = __webpack_public_path__ + "static/media/guide-line-04.0c54eda8.svg";